// Package imports
import React, { useContext } from 'react';
import { ColorRing } from 'react-loader-spinner';

// CSS imports
import './Spinner.css';

// Provider imports
import { ThemeContext } from '../../providers/ThemeProvider';

type Props = {
  className?: string;
  isLoading: boolean;
  height?: number;
  width?: number;
  color?: string;
};

const Spinner: React.FC<Props> = ({
  className,
  isLoading,
  height,
  width,
  color,
}: Props) => {
  const { isLight } = useContext(ThemeContext);

  return isLoading ? (
    <div className={`Spinner ${className ? className : ''}`}>
      <ColorRing
        visible={true}
        height={height ? height : 50}
        width={width ? width : 50}
        ariaLabel='color-ring-loading'
        wrapperStyle={{}}
        wrapperClass='loader-wrapper'
        colors={
          color
            ? [color, color, color, color, color]
            : isLight
            ? ['#000000', '#000000', '#000000', '#000000', '#000000']
            : ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF']
        }
      />
    </div>
  ) : null;
};

export default Spinner;
